import {
    EChartsOption,
} from '@/components/ECharts';
import { BarSeriesOption, LineSeriesOption } from 'echarts';
import { currencyFormat } from '@/dashboards/CompetitorsMediaInvestment/helpers/currencyFormat';

type ChartOptions = EChartsOption<BarSeriesOption | LineSeriesOption>;

export const getGraphData = ({
    seriesData,
    xAxisData,
    formatNumber,
    period,
}: {
    xAxisData: string[];
    seriesData: {
        [key: string]: {
            data: { [key: string]: number };
            color: string;
        };
    };
    period: string | undefined;
    formatNumber: (val: number) => string;
}): ChartOptions => {
    const dates = xAxisData.filter((date, index) => {
        return xAxisData.indexOf(date) === index;
    });

    const series: ChartOptions['series'] = Object.entries(seriesData).map(
        ([key, { data, color }]) => {
            return {
                name: key,
                type: 'line',
                stack: 'Total',
                symbolSize: 2,
                showSymbol: false,
                symbol: 'none',
                triggerLineEvent: true,
                areaStyle: {},
                color: color,
                sampling: 'lttb',
                progressive: 2000,
                progressiveThreshold: 3000,
                data: Object.entries(data).map(([name, value]) => ({
                    name,
                    value,
                })),
            } as unknown as ChartOptions['series'][0];
        },
    );

    return {
        animation: true,
        tooltip: {
            show: false,
            trigger: 'axis',
            triggerOn: 'mousemove|click',
            backgroundColor: 'transparent',
            borderWidth: 0,
            padding: 0,
            type: 'item',
            confine: true,
            extraCssText: 'max-width: 600px; white-space: pre-wrap;',
            formatter: '',
        },
        legend: {
            show: false,
        },
        dataZoom: [
            {
                type: 'inside',
                xAxisIndex: [0],
                zoomOnMouseWheel: 'ctrl',
                moveOnMouseWheel: false,
                moveOnMouseMove: true,
                throttle: 50,
            },
            {
                id: 'dataZoomX',
                type: 'slider',
                xAxisIndex: [0],
                bottom: 10,
                labelFormatter: '',
                textStyle: { show: false },
                throttle: 50,
            },
        ],
        grid: {
            right: '7%',
            left: '7%',
            bottom: '15%',
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: true,
                show: true,
                position: 'top',
                axisLine: {
                    show: false,
                },
                data: dates,
                axisLabel: {
                    rotate: 90,
                    margin: period === 'yearly' ? 30 : 20,
                },
            },
        ],
        yAxis: [
            {
                type: 'value',
                axisLabel: {
                    formatter: (value: number) => formatNumber(Number(value)),
                },
                axisLine: {
                    show: false,
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        opacity: 0.1,
                    },
                },
            },
            {
                type: 'value',
                axisLabel: {
                    formatter: (value: number) =>
                        currencyFormat.format(Number(value)),
                },
                axisLine: {
                    show: false,
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        opacity: 0.1,
                    },
                },
            },
        ],
        series: series,
    };
};
